import { render, staticRenderFns } from "./form-tipo-produto.vue?vue&type=template&id=e0389d10&"
import script from "./form-tipo-produto.vue?vue&type=script&lang=js&"
export * from "./form-tipo-produto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports